import { CARD_TYPE } from 'consts/enum';
import { carouselLeft } from 'icons/carouselLeft';
import { carouselRight } from 'icons/carouselRight';
import './carousel.scss';

export const CarouselTemplate = (model, id) => {
	const { style = '', cards, type = CARD_TYPE.SMALL } = model || {};

	/* html */
	const html = `
		<div class="engt-carousel-${type.toLowerCase()}" id="${id}"
			style="${style || ''} --slide-count: ${cards.length};"
			data-active-slide="0" data-slide-length=${cards.length} data-id-no="${id}">
			  	<cards></cards>
				<div class="engt-carousel-overlay"></div>
		</div>
    `;

	return html;
};

export const CarouselDotsTemplate = (model) => {
	const { cards } = model || {};

	const dots = cards
		.map(
			(_, dotId) =>
				/* html */
				`<div class="dot ${dotId === 0 ? 'dot-active' : ''}"></div>`
		)
		.join('');

	/* html */
	const html = `
		<div class="arrow-left arrow-left-disabled">
			${carouselLeft()}
		</div>
		${dots}
		<div class="arrow-right ${dots.length <= 1 ? 'arrow-rigth-disabled' : ''}">
			${carouselRight()}
		</div>
    `;

	return html;
};
